import { Component, Children } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import { func, dom, events } from '../util';
import position from './utils/position';
import findNode from './utils/find-node';

const { noop } = func;
const { getStyle } = dom;
const { place } = position;

export default class Position extends Component {
  static VIEWPORT = position.VIEWPORT;

  static propTypes = {
    role: PropTypes.string,
    children: PropTypes.node,
    visible: PropTypes.bool,
    container: PropTypes.any,
    target: PropTypes.any,
    align: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    offset: PropTypes.array,
    beforePosition: PropTypes.func,
    onPosition: PropTypes.func,
    needAdjust: PropTypes.bool,
    needListenResize: PropTypes.bool,
    needListenScroll: PropTypes.bool,
    shouldUpdatePosition: PropTypes.bool,
    rtl: PropTypes.bool,
  };

  static defaultProps = {
    align: 'tl bl',
    offset: [0, 0],
    beforePosition: noop,
    onPosition: noop,
    needAdjust: true,
    needListenResize: true,
    needListenScroll: true,
    shouldUpdatePosition: false,
    rtl: false,
  };

  componentDidMount() {
    this.setPosition();

    if (this.props.needListenResize) {
      events.on(window, 'resize', this.handleResize);
    }

    if (this.props.needListenScroll) {
      events.on(window, 'scroll', this.handleResize);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      ('align' in nextProps && nextProps.align !== this.props.align) ||
      nextProps.shouldUpdatePosition || (!this.props.visible && nextProps.visible)
    ) {
      this.shouldUpdatePosition = true;
    }
  }

  componentDidUpdate() {
    if (this.shouldUpdatePosition) {
      this.setPosition();
      this.shouldUpdatePosition = false;
    }
  }

  componentWillUnmount() {
    if (this.props.needListenResize) {
      events.off(window, 'resize', this.handleResize);
    }
    if (this.props.needListenScroll) {
      events.off(window, 'scroll', this.handleResize);
    }

    clearTimeout(this.resizeTimeout);
  }

  setPosition() {
    const { role, align, offset, visible, beforePosition, onPosition, needAdjust, rtl } = this.props;
    if (!visible) {
      return;
    }
    beforePosition();

    const contentNode = this.getContentNode();
    const targetNode = this.getTargetNode();
    const containerNode = this.getContainerNode(this.props);
    if (contentNode && targetNode) {
      const resultAlign = place({
        role,
        pinElement: contentNode,
        baseElement: targetNode,
        align,
        offset,
        needAdjust,
        isRtl: rtl,
        containerNode,
      });
      const top = getStyle(contentNode, 'top');
      const left = getStyle(contentNode, 'left');
      onPosition(
        {
          align: resultAlign.split(' '),
          top,
          left,
        },
        contentNode,
      );
    }
  }

  getContentNode() {
    return findDOMNode(this);
  }

  getContainerNode(props) {
    const targetNode = findNode(props.target);
    return findNode(props.container, targetNode);
  }

  getTargetNode() {
    const { target } = this.props;
    return target === position.VIEWPORT ? position.VIEWPORT : findNode(target, this.props);
  }

  handleResize = () => {
    clearTimeout(this.resizeTimeout);

    this.resizeTimeout = setTimeout(() => {
      this.setPosition();
    }, 200);
  }

  render() {
    return Children.only(this.props.children);
  }
}
